import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";

export const interfaceConfig: InterfaceConfig = {
  name: "lendia",
  interest_rate: 30,
  maps: {
    api_key:
      import.meta.env.VITE_ENV === "PROD"
        ? "AIzaSyDAtCLTqWu3XTjTC6AT2ZysdXUtL33bAX4"
        : "AIzaSyAPkyPkzcAbvKAageB8UN25PKbzl4stiWc",
  },
  companyNames: ["Lendit Group SAPI de CV"],
  home_url: "",
  metadata: {
    title: "",
    description: "",
    favicon: "",
    keywords: undefined,
    ogImage: undefined,
  },
  navbar: {
    logo: "",
    logo_width: undefined,
    logo_height: undefined,
    logo_menu_lateral: undefined,
  },
  lateral: {
    logo_dark: "",
    bg_dark: "",
    text_dark: "",
    logo_light: "",
    bg_light: "",
    text_light: "",
    logo_width: undefined,
    logo_height: undefined,
    image_list: undefined,
    text_list: undefined,
  },
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_UBwoTKTYd",
      userPoolClientId: "4gpsdcqvm7liflkvqsg2l4g9cj",
    },
    guarantee: {
      userPoolId: "us-east-1_EdJB8vOre",
      userPoolClientId: "1gtf94j5udovq9deu5u13bbhvn",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_cZ3l5Oi5V",
      userPoolClientId: "77ka51qoact8o1u8dqh1p5q9j9",
    },
    guarantee: {
      userPoolId: "us-east-1_78qrlwJTD",
      userPoolClientId: "451cn0u2mau2ipp479c39d75m5",
    },
  },
};
